import { render, staticRenderFns } from "./AgreementNotification.vue?vue&type=template&id=42cddd1f&"
import script from "./AgreementNotification.js?vue&type=script&lang=js&"
export * from "./AgreementNotification.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports